import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'

import BuildingCard from 'containers/BuildingCard/BuildingCard.jsx'
import BuildingsCarousel from 'containers/BuildingsCarousel/BuildingsCarousel.jsx'
import CommandCenterCard from 'containers/CommandCenterCard/CommandCenterCard.jsx'

import BuildingTooltip from 'components/BuildingTooltip/BuildingTooltip.jsx'
import CommandCenterTooltip from 'components/CommandCenterTooltip/CommandCenterTooltip.jsx'
import Back from 'components/Back/Back.jsx'


import { STRONGHOLD } from 'urls'
import {
    CAROUSEL_BUILDING_TOOLTIP_ID,
    CAROUSEL_COMMAND_CENTER_TOOLTIP_ID,
    COMMAND_CENTER_ID,
} from 'constants'

import styles from './BuildingView.scss'
import { changeSelectedLevel } from 'state/actions/reserve_level_select'
import { getSortedProductionReserves } from 'helpers/reserves'

export class BuildingView extends React.Component {
    static propTypes = {
        pushState: PropTypes.func.isRequired,
        buildings: PropTypes.array.isRequired,
        buildingId: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]).isRequired,
        level: PropTypes.number.isRequired,
        selectedLevel: PropTypes.number.isRequired,
        buildingLevel: PropTypes.number.isRequired,
        changeSelectedLevel: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)
        props.changeSelectedLevel(props.selectedLevel)
    }

    componentDidUpdate({ buildingId, buildingLevel }) {
        if (buildingId !== this.props.buildingId || buildingLevel !== this.props.buildingLevel) {
            this.props.changeSelectedLevel(this.props.selectedLevel)
        }
    }

    getTooltips() {
        const tooltips = this.props.buildings
            .map(building => {
                return (
                    <BuildingTooltip
                        key={`${CAROUSEL_BUILDING_TOOLTIP_ID}_${building.type}`}
                        id={`${CAROUSEL_BUILDING_TOOLTIP_ID}_${building.type}`}
                        building={building}
                    />
                )
            })
        tooltips.push(
            <CommandCenterTooltip
                key={CAROUSEL_COMMAND_CENTER_TOOLTIP_ID}
                id={CAROUSEL_COMMAND_CENTER_TOOLTIP_ID}
                level={this.props.level}
            />
        )
        return tooltips
    }

    render() {
        let building
        if (this.props.buildingId === COMMAND_CENTER_ID) {
            building = <CommandCenterCard key={COMMAND_CENTER_ID} />
        } else {
            building = <BuildingCard buildingId={this.props.buildingId} key={`building_${this.props.buildingId}`} />
        }

        return (
            <div className={styles.base}>
                <div className={styles.view}>
                    <div className={styles.back}>
                        <Back handleClick={this.props.pushState.bind(null, STRONGHOLD)} />
                    </div>
                    <ReactCSSTransitionGroup
                        transitionName='building'
                        transitionAppear
                        transitionAppearTimeout={500}
                        transitionEnter
                        transitionEnterTimeout={500}
                        transitionLeave
                        transitionLeaveTimeout={200}
                    >
                        {building}
                    </ReactCSSTransitionGroup>
                </div>
                <div className={styles.carousel}>
                    <BuildingsCarousel selectedBuildingId={this.props.buildingId} />
                </div>
                {this.getTooltips()}
            </div>
        )
    }
}
export const mapStateToProps = (state, ownProps) => {
    const { stronghold } = state
    const buildingId = parseInt(ownProps.params.buildingId) || ownProps.params.buildingId
    const { level } = stronghold

    const buildings = Object.keys(state.buildings).map(buildingId => {
        const { id, name, type, level } = state.buildings[buildingId]
        return { id, name, type, level }
    })

    let selectedLevel = 1
    let buildingLevel = 1
    const building = state.buildings[buildingId]
    if (building) {
        const reserveType = state.settings.buildings[building.type].reserve_type
        const reserves = getSortedProductionReserves(state.clanReserves[reserveType])
        selectedLevel = reserves[0] ? reserves[0].level : building.level
        buildingLevel = building.level
    }

    return {
        buildings,
        buildingId,
        selectedLevel,
        buildingLevel,
        level,
    }
}

export const mapDispatchToProps = {
    pushState: push,
    changeSelectedLevel,
}

export default connect(mapStateToProps, mapDispatchToProps)(BuildingView)



// WEBPACK FOOTER //
// ./containers/BuildingView/BuildingView.jsx